<template>
<div class="yo-bg-color-chiaro" style="padding:20px 10px; ">

   <div class="col s12 yo-text-xl yo-text-bold yo-spacing-s black" style="padding:20px 50px;">MODIFICA IL TUO PROFILO</div>

  <el-form ref="form" :model="$contatto.row" v-on:submit.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">
  
    <div class="row">

<!--    
      <div class="col s12 m6">
      <el-form-item label="Cognome" prop="cognome">
        <el-input  v-model="$contatto.row.cognome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Nome" prop="nome">
        <el-input  v-model="$contatto.row.nome"></el-input>
      </el-form-item>
      </div> 
-->

      <div class="col s12 m6">
      <el-form-item label="Nazione di nascita" prop="natonazione">
        <el-select v-model="$contatto.row.natonazione" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;" v-on:change="$contatto.row.natoprovincia=$contatto.row.natocitta=''">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$contatto.row.natonazione=='ITA'">
      <el-form-item label="Provincia di nascita" prop="natoprovincia">
        <el-select v-model="$contatto.row.natoprovincia" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;" v-on:change="$contatto.row.natocitta=''">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6 clear">
      <el-form-item label="Città di nascita" prop="natocitta">
         <el-select v-if="$contatto.row.natonazione=='ITA'" v-model="$contatto.row.natocitta" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;">
            <el-option v-for="item in _natocitta" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
         </el-select>
        <el-input v-if="$contatto.row.natonazione!='ITA'" v-model="$contatto.row.natocitta"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Sesso" prop="sesso">
        <el-select v-model="$contatto.row.sesso"  placeholder="Selezionare dalla lista" style="width:100%;">
          <el-option label="Maschio" value="M" ></el-option>
          <el-option label="Femmina" value="F" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6 clear">
      <el-form-item label="Data di nascita" prop="natodata" class="is-required">
        <el-date-picker v-model="$contatto.row.natodata" type="date" placeholder="dd-mm-yyyy" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Codicefiscale" prop="codicefiscale">
        <el-input  v-model="$contatto.row.codicefiscale"></el-input>
      </el-form-item>
      </div> 

      









      <div class="col s12 yo-text-n yo-text-bold yo-spacing-s black" style="padding:20px 50px;">RECAPITI</div>
      
      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$contatto.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Mobile phone" prop="cellulare">
        <el-input  v-model="$contatto.row.cellulare"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 yo-text-n yo-text-bold yo-spacing-s black" style="padding:20px 50px;">RESIDENZA</div>


      <div class="col s12">
      <el-form-item label="Indirizzo" prop="address">
        <el-input  v-model="$contatto.row.address"></el-input>
      </el-form-item>
      </div>


      <div class="col s12 m6">
      <el-form-item label="Nazione" prop="nazione">
        <el-select v-model="$contatto.row.nazione" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;" v-on:change="$contatto.row.provincia=$contatto.row.citta=''">
          <el-option v-for="item in $teras._nazione" :key="item.id" :label="item.nome" :value="item.iso3" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6" v-if="$contatto.row.nazione=='ITA'">
      <el-form-item label="Provincia" prop="natoprovincia">
        <el-select v-model="$contatto.row.provincia" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;" v-on:change="$contatto.row.citta=''">
          <el-option v-for="item in $teras._provincia" :key="item.sigla" :label="item.nome" :value="item.sigla" ></el-option>
        </el-select>
      </el-form-item>
      </div>

      <div class="col s12 m6 clear">
      <el-form-item label="Città di nascita" prop="citta">
         <el-select v-if="$contatto.row.nazione=='ITA'" v-model="$contatto.row.citta" filterable clearable placeholder="Selezionare dalla lista" style="width:100%;">
            <el-option v-for="item in _citta" :key="item.id" :label="item.nome" :value="item.nome" ></el-option>
         </el-select>
        <el-input v-if="$contatto.row.nazione!='ITA'" v-model="$contatto.row.citta"></el-input>
      </el-form-item>
      </div> 



      <div class="col s12 m6">
      <el-form-item label="ZIP code" prop="cap">
        <el-input  v-model="$contatto.row.cap"></el-input>
      </el-form-item>
      </div> 


      <div class="col s12 yo-text-n yo-text-bold yo-spacing-s black" style="padding:20px 50px;">INTERESSI PROFESSIONALI</div>

      <div class="col s12 clear">
      <el-form-item label="Aree di competenza" prop="interesse">
         <el-select v-model="$contatto.row.interesse" multiple clearable placeholder="Selezionare dalla lista" style="width:100%;">
            <el-option v-for="item in $teras._interesse" :key="item.id" :label="item.nome" :value="item.id" ></el-option>
         </el-select>
      </el-form-item>
      </div> 


    </div>


    <div class="row pad">
      <div class="col s12 m4 offset-m2"><el-button style="width:100%;" @click="onCancel">Indietro</el-button></div>
      <div class="col s12 m4 offset-m2"><el-button type="primary" @click="onSubmit" style="width:100%;">Salva</el-button></div>
    </div>







  



  </el-form>
</div>
</template>

<script>
export default {
   name: 'contatto-edit',
   components: {

   },
   created () {
      this.$teras.page.title = "Mylogin Profilo"
      this.$teras.page.sezione = "myLogin"
   },
   data() {
      return {
         checkEmail: function (rule, value, callback)  {
            console.log(this.emailcheck)
            if(typeof value !='undefined')
               if (value.toString()!=this.$contatto.row.email) {
                  return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
               }else{
                  callback();
               }
         }
      }
   },
   beforeDestroy () {
   },
   methods: {
      onChange(editor, content){
         console.log(".................................................................................:"+editor)
         //this.form.note = editor
      },
      onCancel() {
         this.$router.go(-1)
      },
      onSubmit() {
         this.$refs.form.validate((valid) => {
            if (valid) {
               var parent = this
               this.$contatto.checkEmail(this.$contatto.row.email,this.$contatto.row.id).then(function (data) {
                  if(data){
                     parent.Save()
                  }else{
                     this.$alert('L\'indirizzo email scelto è già associato ad un altro contatto, sceglierne uno differente!','Impossibile procedere',{type: 'error',dangerouslyUseHTMLString: true})
                     return false
                  }
               })
            } else {
               return false
            }
         })
      },
      Save(){
         var parent = this
         this.$contatto.save().then((data) => {
            parent.$router.push('/mylogin-home/')
         })
      }

   },
   computed: {
      rules:function() {
         var rulesNow = {
         natonazione: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur,change' }
         ],
         natoprovincia: [
            { required: (this.$contatto.row.natonazione=='ITA'), message: 'Campo Obbligatorio', trigger: 'blur,change' }
         ],
         natocitta: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' }
         ],
         natodata: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' }
         ],
         codicefiscale: [
            { required: (this.$contatto.row.nazione=='ITA'), message: 'Campo Obbligatorio', trigger: 'blur' }
         ],
         
         nazione: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur,change' }
         ],
         provincia: [
            { required: (this.$contatto.row.nazione=='ITA'), message: 'Campo Obbligatorio', trigger: 'blur,change' }
         ],
         citta: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' }
         ],
         address: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' }
         ],


         email: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' },
            { type: 'email', message: 'Email non corretta', trigger: 'blur,change' }
         ],
         
         cellulare: [
            { required: true, message: 'Campo Obbligatorio', trigger: 'blur' }
         ],
         
         cap: [
            { required: true, message: 'Home ZIP code is mandatory', trigger: 'blur' }
         ],
         citta: [
            { required: true, message: 'Home city is mandatory', trigger: 'blur' }
         ],
         nazione: [
            { required: true, message: 'Home country is mandatory', trigger: 'blur' }
         ],
         ente: [
            { required: true, message: 'Institute is mandatory', trigger: 'blur' }
         ],
         addresslavoro: [
            { required: true, message: 'Work address is mandatory', trigger: 'blur' }
         ],
         caplavoro: [
            { required: true, message: 'Work ZIP code is mandatory', trigger: 'blur' }
         ],
         cittalavoro: [
            { required: true, message: 'Work city is mandatory', trigger: 'blur' }
         ],
         nazionelavoro: [
            { required: true, message: 'Work country is mandatory', trigger: 'blur' }
         ]   
         }
         return rulesNow
      },
      _natocitta: function(){
         var itemFilter = []
         for (let item of this.$teras._comune){
            if(item.provincia == this.$contatto.row.natoprovincia)
               itemFilter.push(item) 
         }
         return itemFilter
      },
      _citta: function(){
         var itemFilter = []
         for (let item of this.$teras._comune){
            if(item.provincia == this.$contatto.row.provincia)
               itemFilter.push(item) 
         }
         return itemFilter
      }
   }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Contatto-edit.vue